import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#5f0397',
      light: '#7029A0',
      dark: '#470271',
    },
    secondary: {
      main: '#1A92C0',
      light: '#4DB6D6',
      dark: '#136B8C',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    h1: {
      fontSize: '3.25rem',
      fontWeight: 700,
      color: 'inherit',
    },
    h2: {
      fontSize: '2.288rem',
      fontWeight: 600,
      color: 'inherit',
    },
    h3: {
      fontSize: '1.988rem',
      fontWeight: 600,
      color: 'inherit',
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 500,
      color: 'inherit',
    },
    h5: {
      fontSize: '1.35rem',
      fontWeight: 500,
      color: 'inherit',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: 'inherit',
    },
    body1: {
      fontSize: '1.125rem',
      color: '#1E082C',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '1.875rem',
          fontSize: '1.12rem',
          fontWeight: 700,
          textTransform: 'none',
          padding: '12px 32px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          radii: {
            topLeft: "12px",
            topRight: "12px",
            bottomLeft: "0px",
            bottomRight: "0px",
          },
        },
      },
    },
  },
});